<template>
  <div class="total-count-container">
    <span class="total-count">Total: {{ count }}</span>
  </div>
</template>

<script>

export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss">
.total-count-container {
  margin-top: -26px;
}
.total-count {
  font-size: 16px;
  font-weight: 500;
}
</style>
